import { createContext } from 'react'
import { TPagesContext } from './types'

export const PagesContext = createContext<TPagesContext>({

})